import { ButtonVariant } from "@amzn/stencil-react-components/button";
import { RenderModalFunctionParams, WithModal } from "@amzn/stencil-react-components/modal";
import { Button } from "@amzn/uxm-stencil-react-components/lib/src/stencil";
import { getString } from "common/uistringlabels/uiStringUtils";
import { Visibility } from "lib/models/list-models";
import { ItemModel } from "lib/services/catalogical-models";
import React from "react";

import ListAdminModal from "./ListAdminModal";
import ListModal from "./ListModal";

export enum LIST_MODAL_TYPE {
  EDIT = "EDIT",
  CREATE = "CREATE",
  ADMIN = "ADMIN",
  ADMIN_EDIT = "ADMIN_EDIT",
}
interface ListModalButtonProps {
  initialData?: {
    name?: string;
    description?: string;
    visibility?: Visibility;
    allowedDomains?: string[];
    items?: ItemModel[];
    evaluationRules?: any;
    ownershipBindle?: string;
    sharedWithBindle?: string;
  };
  listId?: string;
  type?: LIST_MODAL_TYPE;
  buttonText?: string;
  variant?: ButtonVariant;
  jobFamilies?: string[];
  disable?: boolean;
}

const MODAL_CONFIG: Record<string, { touchpoint: string; textKey: string }> = {
  EDIT: { touchpoint: "list-modal-edit", textKey: "lists.editList" },
  ADMIN: { touchpoint: "list-modal-admin-create", textKey: "lists.createListAdmin" },
  ADMIN_EDIT: { touchpoint: "list-modal-admin-edit", textKey: "lists.editList" },
  CREATE: { touchpoint: "list-modal-create", textKey: "lists.createList" },
};

const ListModalButton: React.FC<ListModalButtonProps> = ({
  initialData,
  listId,
  type = LIST_MODAL_TYPE.CREATE,
  buttonText,
  variant = ButtonVariant.Primary,
  jobFamilies,
  disable = false,
}) => {
  const renderModal = ({ close }: RenderModalFunctionParams) => {
    switch (type) {
      case LIST_MODAL_TYPE.ADMIN:
        return <ListAdminModal onClose={close} jobFamiliesProp={jobFamilies} domains={["aiforme"]} />;
      case LIST_MODAL_TYPE.ADMIN_EDIT:
        return (
          <ListAdminModal
            onClose={close}
            initialData={initialData}
            listId={listId}
            jobFamiliesProp={jobFamilies}
            isEdit
            domains={["aiforme"]}
          />
        );
      case LIST_MODAL_TYPE.EDIT:
        return <ListModal onClose={close} initialData={initialData} listId={listId} isEdit />;
      case LIST_MODAL_TYPE.CREATE:
      default:
        return <ListModal onClose={close} listId={listId} />;
    }
  };

  return (
    <WithModal renderModal={renderModal}>
      {({ open }) => (
        <Button
          touchpoint={MODAL_CONFIG[type].touchpoint}
          variant={variant}
          onClick={open}
          disabled={disable}
          data-cy="list-modal-button"
        >
          {buttonText || getString(MODAL_CONFIG[type].textKey)}
        </Button>
      )}
    </WithModal>
  );
};

export default ListModalButton;
